<template>

  <div>
    <div>
      <aside class="bg-primary bg-gradient rounded-1 p-0 p-sm-1 mt-1">
        <div
            class="d-flex align-items-center justify-content-between flex-column flex-xl-row text-center text-xl-start">
          <div class="mb-4 mb-xl-0">
            <div class="fs-3 fw-bold text-white">Reporte TIER</div>
            <div class="text-white-50">En ésta sección podrás generar el reporte TIER</div>
          </div>
          <div class="ms-xl-4">
            <div class="input-group mb-2">
              <DatePicker v-model="filtros.rango"
                          range lang="es"
                          placeholder="Fechas"
                          circle
                          show-clear-button
                          :date-format="{
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric' }"
                          :disabled-start-date="disabledStartDate"
                          :disabled-end-date="disabledEndDate"
              />
            </div>
          </div>
        </div>
      </aside>

      <div class="container px-lg-3 px-xl-2 px-xxl-2 mt-2">
        <div class="row ">

          <div class="col-4">
            <div class="input-group">
              <span class="input-group-text">Cliente</span>
              <input v-model="filtros.cliente"
                     style="float: right;"
                     class="form-control"
                     placeholder="Nombre del cliente"
                     @keydown.prevent.enter="obtener()"
              />
              <button type="button" class="input-group-text" style="float: right;" @click="filtros.cliente=null"
                      v-if="filtros.cliente!=null">
                <FontAwesomeIcon :icon="faClose()" title="Restablecer nombre del cliente"/>
              </button>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group">
              <span class="input-group-text">Sucursal</span>
              <input v-model="filtros.sucursal"
                     style="float: right;"
                     class="form-control"
                     placeholder="Nombre de la sucursal"
                     @keydown.prevent.enter="obtener()"
              />
              <button type="button" class="input-group-text" style="float: right;" @click="filtros.sucursal=null"
                      v-if="filtros.sucursal!=null">
                <FontAwesomeIcon :icon="faClose()" title="Restablecer nombre de la sucursal"/>
              </button>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group">
              <span class="input-group-text">Empleado</span>
              <input v-model="filtros.empleado"
                     style="float: right;"
                     class="form-control"
                     placeholder="Nombre del empleado"
                     @keydown.prevent.enter="obtener()"
              />
              <button type="button" class="input-group-text" style="float: right;" @click="filtros.empleado=null"
                      v-if="filtros.empleado!=null">
                <FontAwesomeIcon :icon="faClose()" title="Restablecer nombre del empleado"/>
              </button>
            </div>
          </div>
          <div class="col-12">
            <button type="button" class=" mt-2 btn btn-success" style="float: right;" @click="obtener()">
              <FontAwesomeIcon :icon="faSearch()"/>
              Generar y Descargar
            </button>
          </div>

        </div>
      </div>

    </div>

  </div>

</template>

<script>

import {inject} from "vue";
import {faClose, faPlus, faSearch} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {TierService} from "@/services/TierService";

export default {
  name: 'Tier-Component',
  components: {
    FontAwesomeIcon
  },
  inject: ['$axios', '$localStorageService'],
  setup() {
    return {
      srv_TierService: new TierService(inject('$axios'))
    }
  },
  props: {},
  data() {
    return {
      filtros: {
        sucursal: null,
        cliente: null,
        empleado: null,
        rango: [
          new Date(new Date().toDateString()),
          new Date(new Date().toDateString())
        ]
      },
    }
  },
  async mounted() {

  },
  methods: {
    faPlus() {
      return faPlus;
    },
    faSearch() {
      return faSearch;
    },
    faClose() {
      return faClose;
    },
    disabledStartDate: {
      to: new Date()
    },
    disabledEndDate: {
      from: new Date()
    },
    async obtener() {

      if (this.filtros.rango == null || this.filtros.rango[0] == null || this.filtros.rango[1] == null) {
        this.$swal.fire({
          icon: "alarm",
          text:'Debes seleccionar un rango de fechas'
        });
        return;
      }

      let load = this.$loading.show({
        container: this.$refs.formContainer,//puede ponerse null
        canCancel: false,
        onCancel: this.onCancelLoader,
      });

      this.filtros.fcInicio = new Date(this.filtros.rango[0]).toDateString()
      this.filtros.fcFin = new Date(this.filtros.rango[1]).toDateString()

      await this.srv_TierService.obtenerReporte(this.filtros).then((response) => {
        const byteCharacters = atob(response); // Decode Base64 string
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const url = new Blob([byteArray],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;'});

        const a = document.createElement("a"); //Create <a>
        a.href = URL.createObjectURL(url); //Image Base64 Goes here
        a.setAttribute('download', "Tier.xlsx");
        a.click(); //Downloaded file
      }).catch((error) => {
        console.error(error)
        this.$swal(error.message);
      }).finally(() => load.hide());
    },
  }
}
</script>

<style scoped>
.header {
  position: sticky;
  top: 0;
}
.header1 {
  position: sticky;
  top: 39px;
}
</style>